"use client";

import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

interface ProtocolTvlChartProps {
  data: Array<{ timestamp: number; tvl: number }>;
}

function formatUsd(value: number): string {
  if (value >= 1e12) return `$${(value / 1e12).toFixed(1)}T`;
  if (value >= 1e9) return `$${(value / 1e9).toFixed(1)}B`;
  if (value >= 1e6) return `$${(value / 1e6).toFixed(1)}M`;
  if (value >= 1e3) return `$${(value / 1e3).toFixed(0)}K`;
  return `$${value.toFixed(0)}`;
}

function formatDate(timestamp: number): string {
  return new Date(timestamp).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "2-digit",
  });
}

export function ProtocolTvlChart({ data }: ProtocolTvlChartProps) {
  return (
    <div className="h-64 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 5, right: 5, bottom: 5, left: 0 }}>
          <defs>
            <linearGradient id="tvlGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#3b82f6" stopOpacity={0.6} />
              <stop offset="100%" stopColor="#3b82f6" stopOpacity={0.05} />
            </linearGradient>
          </defs>
          <XAxis
            dataKey="timestamp"
            type="number"
            domain={["dataMin", "dataMax"]}
            tickFormatter={formatDate}
            stroke="#64748b"
            fontSize={11}
            minTickGap={60}
          />
          <YAxis
            tickFormatter={formatUsd}
            stroke="#64748b"
            fontSize={11}
            width={55}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: "hsl(230, 15%, 10%)",
              border: "1px solid hsl(230, 15%, 18%)",
              borderRadius: 8,
              fontSize: 12,
            }}
            labelFormatter={(label) => formatDate(label as number)}
            formatter={(value) => [formatUsd(Number(value)), "TVL"]}
          />
          <Area
            type="monotone"
            dataKey="tvl"
            stroke="#3b82f6"
            strokeWidth={2}
            fill="url(#tvlGradient)"
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
